import {connect} from '@modifi/redux'

import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {withSuspense} from '@modifi/plugin-onboarding'
import {FeInputFieldStatus} from '@modifi/enums'
import {
  selectInitialFormData,
  selectAvailableSellerBankAccountCurrencies,
  aInitializePage,
  selectInitializePagePending,
  aSavePage,
  selectSubmitInProgress,
  selectSubmitErrorMessage,
  selectSubmitHasError,
  selectSubmitErrorFieldErrors,
  aDiscardChanges,
} from './store'
import {selectSellerBankAccountByExternalId} from '../../../data/seller-bank-accounts'
import SellerBankAccount, {SellerBankAccountProps} from './SellerBankAccount'
import {selectCombinedInputFieldStatusBySectionName} from '../../../modules/input-fields'
import {SECTION_BANK_DETAILS} from '../../../constants/sections'
import {selectBankUtilsErrorMessage} from '../../../data/bank-utils'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (
  state: Record<string, any>,
  ownProps: Record<string, any>
): Pick<
  SellerBankAccountProps,
  | 'externalBankAccountId'
  | 'isLoading'
  | 'isValidExternalBankAccountId'
  | 'formData'
  | 'availableCurrencies'
  | 'requestPending'
  | 'errorMessage'
  | 'hasError'
  | 'externalErrors'
  | 'pageIsVerified'
  | 'hasInvalidBankData'
> => {
  const externalBankAccountId = ownProps?.match?.params?.externalBankAccountId

  const isLoading = selectInitializePagePending(state)
  return {
    externalBankAccountId,
    isLoading,
    isValidExternalBankAccountId:
      isLoading ||
      selectSellerBankAccountByExternalId(state, externalBankAccountId)?.externalId ===
        externalBankAccountId,
    formData: selectInitialFormData(state, externalBankAccountId),
    availableCurrencies: selectAvailableSellerBankAccountCurrencies(state, externalBankAccountId),
    requestPending: selectSubmitInProgress(state),
    errorMessage: selectSubmitErrorMessage(state),
    hasError: selectSubmitHasError(state),
    // @ts-expect-error  redux type issue
    externalErrors: selectSubmitErrorFieldErrors(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_BANK_DETAILS) ===
      FeInputFieldStatus.VERIFIED,
    hasInvalidBankData: !!selectBankUtilsErrorMessage(state),
  }
}

const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSavePage,
  onDiscard: aDiscardChanges,
  redirect: aPush,
}

export const ExistingSellerBankAccountPage = compose(
  withSuspense(false),
  connect(mapStateToProps, mapDispatchToProps)
)(SellerBankAccount)
